export const legacyArchiveKeys = {
  all: ['legacyTripArchive'] as const,
  list: (memberId: string) => ['legacyTripArchive', 'list', memberId] as const,
  detail: (tripId: string, isPublic: boolean, memberId: string) => ['legacyTripArchive', 'detail', isPublic, tripId, memberId] as const,
}
